module.exports = __webpack_public_path__ + "img/sunglasses.6edbd057.svg";